import { render } from "./shopPage.vue?vue&type=template&id=6c784972&ts=true"
import script from "./shopPage.vue?vue&type=script&lang=ts"
export * from "./shopPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__